import { render, staticRenderFns } from "./CarouselSkeleton.vue?vue&type=template&id=a8b28d70&"
import script from "./CarouselSkeleton.vue?vue&type=script&lang=js&"
export * from "./CarouselSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports